module.exports = __webpack_public_path__ + "media/truck.15d50798.mp4";